import { render } from "./DbsTableView.vue?vue&type=template&id=100c75cb"
import script from "./DbsTableView.vue?vue&type=script&lang=js"
export * from "./DbsTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__